import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import BaggageCard from './components/Baggage/SpecialEquipment/BaggageCard';
import { Form } from '@websky/core/src/Checkout/components/Checkout/Form/Form';
import SeatInfoGroup from './components/SeatMap/SeatInfoGroup/SeatInfoGroup';
import { InsuranceProductView as InsuranceProductViewV2 } from '@websky/core/src/InsurancePage/components/InsuranceProduct/InsuranceProductViewV2/InsuranceProductView';

export const renders: EngineRenderers = {
	CheckoutForm: props => <Form {...props} showCheckDataModal={true} />,
	SeatInfoGroup,
	Baggage: {
		SpecialEqupment: {
			BaggageCard
		}
	},
	InsuranceProductView: props => (
		<InsuranceProductViewV2
			{...props}
			bannerVariant="titleWithIcon"
			popularPricePosition="bottom"
			fallbackIconUrl={'https://cdn.websky.aero/content/frontend/images/RT/services/insurance/ON_UVT_OWN.svg'}
		/>
	)
};
